import { render, staticRenderFns } from "./purple.vue?vue&type=template&id=37f1b8f3&scoped=true&"
import script from "./purple.vue?vue&type=script&lang=js&"
export * from "./purple.vue?vue&type=script&lang=js&"
import style0 from "./purple.vue?vue&type=style&index=0&id=37f1b8f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1b8f3",
  null
  
)

component.options.__file = "purple.vue"
export default component.exports